module.exports = __webpack_public_path__ + "img/onegate.01f0377f.svg";